import React from "react";
import { MethodIcon } from "./MethodIcon";
import { ReactComponent as SkrillIcon } from "assets/logos/skrill.svg";

import * as styles from "./SkrillMethodIcon.module.scss";

export const SkrillMethodIcon = () => (
  <MethodIcon className={styles.skrillMethodIcon}>
    <SkrillIcon />
  </MethodIcon>
);
